const themedBoxShadow = (theme: any) =>
    `0 4px 12px ${theme.palette.primary.contrastText}50`;


export default themedBoxShadow;